import { render, staticRenderFns } from "./LayoutSidebarPlaceholder.vue?vue&type=template&id=f4e87a92&scoped=true"
import script from "./LayoutSidebarPlaceholder.vue?vue&type=script&lang=js"
export * from "./LayoutSidebarPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LayoutSidebarPlaceholder.vue?vue&type=style&index=0&id=f4e87a92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e87a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4e87a92')) {
      api.createRecord('f4e87a92', component.options)
    } else {
      api.reload('f4e87a92', component.options)
    }
    module.hot.accept("./LayoutSidebarPlaceholder.vue?vue&type=template&id=f4e87a92&scoped=true", function () {
      api.rerender('f4e87a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutSidebarPlaceholder.vue"
export default component.exports